module.exports = __webpack_public_path__ + "img/logitechg603.5cae215d.jpg";